import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    width: `calc(100% - ${theme.spacing(4)}px)`,
    clear: 'both',

    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },

    pageBreakInside: 'avoid !important',
  },
  chkimg: {
    width: `calc(50% - ${theme.spacing(2)}px)`,
    float: 'right',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      float: 'none',
    },

    '& img': {
      width: '100%',
    },

    '@media print': {
      width: '50%',
      float: 'right',
    },
  },
  contentContainer: {
    width: '45%',
    float: 'left',

    [theme.breakpoints.down('lg')]: {
      width: `calc(100% - ${theme.spacing(4)}px)`,
      float: 'none',
      padding: theme.spacing(1),
    },

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0),
    },

    '@media print': {
      float: 'left',
      width: '45%',
    },
  },
  textContainer: {
    width: '100%',
  },
  contentContainerNoImage: {
    margin: 'auto',

    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(4)}px)`,
    },

    '@media print': {
      margin: 'auto',
      width: '55%',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  centerVertically: {
    alignItems: 'center',
  },

  buffer: {
    marginBottom: theme.spacing(5),
    pageBreakInside: 'avoid !important',
    width: '100%',
    float: 'left',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  iconContainer: {
    color: theme.palette.grey[500],
    marginRight: theme.spacing(1),
  },
  title: {
    fontSize: 18,

    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
    },
  },
  rowText: {
    fontSize: 14,

    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(1),
    },

    '@media print': {
      fontSize: 12,
    },
  },
  additionalText: {
    fontWeight: 'bold',
    fontSize: 25,
    marginBottom: theme.spacing(2),
  },
  subText: {
    fontSize: 17,
    marginTop: theme.spacing(1),
  },
  checklistName: {
    fontWeight: 'bold',
    fontSize: 20,
  },
}));

export default useStyles;
